export const state = () => ({
  linkTreeList: [],
});
